module.exports = __webpack_public_path__ + "static/media/smiley-heart-eyes.3cc3a51f.svg";